import {NEW_ID} from '../../../../common/constants/index.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import Archive from './Archive.js'
import Nickname from './Nickname.js'
import {
  formSelector,
  getState,
  onlyIfAutoForm,
  updateForm,
  useSelector,
} from '../../../../store.js'
import {redirect} from '../../../../common/location.js'
import {SHIPPO} from '../../../../common/constants/ShipperNames.js'
import {
  baseShipperFormErrorsSelector,
  baseShipperInitialFormSelector,
  goToShipperSettings,
  simpleSaveShipper,
} from '../ShippersFunctions.js'
import TextInput from '../../Common/TextInput.js'

export function setUpShipperForm({shipper, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {shipper}),
      errorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  return baseShipperFormErrorsSelector(state, {formName})
}

export function initialFormSelector(state, {shipper}) {
  const vendorConfig = shipper?.vendor_config || {}

  return {
    ...baseShipperInitialFormSelector(state, {shipper, vendor: SHIPPO}),
    certify_signer: vendorConfig.certify_signer || '',
  }
}

export function authorize(formName) {
  const {id} = formSelector(getState(), {formName})

  const params = {
    shipper_id: id && id !== NEW_ID ? id : undefined,
  }

  return redirect(null, ['verde', 'shippo', 'start'], params)
}

export async function saveShipperShippo(formName) {
  const form = formSelector(getState(), {
    formName,
  })

  const params = {
    certify_signer: form.certify_signer.trim(),
  }

  return simpleSaveShipper(formName, params)
}

function ShippoForm({formName, form}) {
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))

  return (
    <div className="settings-list-item-form-wrap settings-list-item-form-cp clear-both">
      <div className="medium-6 columns">
        {form.id !== NEW_ID && (
          <fieldset>
            <ul className="form-list">
              <Nickname formName={formName} />
              <li className="form-list-item bigger margin-bottom-20">
                <TextInput
                  label="Certify Signer"
                  name="certify_signer"
                  value={form.certify_signer}
                  onChange={(event) =>
                    updateForm(formName, {
                      certify_signer: event.target.value,
                      hasChanged_certify_signer: true,
                    })
                  }
                  errorMessage={
                    form.hasChanged_certify_signer && errors.certify_signer
                  }
                />
                <p className="fs-00 lh-md margin-bottom-10">
                  <em>
                    Name of the person who can certify the shipment is correctly
                    configured.
                  </em>
                </p>
              </li>
              <li className="list__item list__item--no-style padding-bottom-20 divider--bottom">
                <ButtonPrimary
                  className="btn--primary-alt"
                  isLoading={form.isSaving}
                  isDisabled={errors.preventSave}
                  onClick={() => saveShipperShippo(formName)}
                >
                  Update
                </ButtonPrimary>
              </li>
            </ul>
          </fieldset>
        )}
        <fieldset>
          <ul className="form-list">
            <li className="form-list-item helper-li">
              You will be directed to the Shippo admin to authorize Ordoro to
              use your Shippo account to print shipping labels.
            </li>
            <li className="form-list-item margin-top-20">
              <ButtonPrimary onClick={() => authorize(formName)}>
                {form.id !== NEW_ID ? 'Reauthorize' : 'Authorize'}
              </ButtonPrimary>
              <ButtonSecondary onClick={() => goToShipperSettings()}>
                Cancel
              </ButtonSecondary>
            </li>
          </ul>
        </fieldset>
      </div>

      {form.id !== NEW_ID && (
        <div className="medium-5 columns">
          <div className="alert margin-bottom-10 alert--standard">
            <Archive formName={formName} />
          </div>
        </div>
      )}
    </div>
  )
}

export default onlyIfAutoForm(ShippoForm, setUpShipperForm)
